/**
 * This file contains all the dimensions used by the basketball game.
 * These constants are shared between client and server to ensure
 * consistent physics and visualization.
 */

export const BasketballDimensions = {

  floor: {
    width: 22.1168,
    length: 33.5268,
  },

  // Court dimensions (NBA regulation size)
  court: {
    width: 15.24, // 50 feet = 15.24 meters
    length: 28.65, // 94 feet = 28.65 meters
    borderWidth: 2 * 2.4384, // 8 feet = 2.4384 meters
    lineWidth: 0.0508 * 2, // 2 inches = 0.0508 meters (with enlargeFactor of 2)
  },

  // Ball dimensions
  ball: {
    radius: 0.24, // Official basketball radius (approx 9.4 inches = 0.24 meters)
    bounceFactor: 0.7, // How bouncy the ball is
  },

  // Backboard dimensions
  backboard: {
    width: 1.83, // 6 feet = 1.83 meters
    height: 1.07, // 3.5 feet = 1.07 meters
    depth: 0.03, // 3 cm = 0.03 meters
    rectangleWidth: 0.61, // 24 inches = 0.61 meters
    rectangleHeight: 0.46, // 18 inches = 0.46 meters
    rectangleLineWidth: 0.05, // 2 inches = 0.05 meters
  },

  // Rim dimensions
  rim: {
    radius: 0.225, // 9 inches = 0.225 meters (internal diameter of 18 inches)
    tubeRadius: 0.02, // Thickness of the rim
    heightAboveGround: 3.05, // 10 feet = 3.05 meters
    distanceFromBackboard: 0.15, // 6 inches = 0.15 meters (to nearest inside edge)
    heightAboveBackboardBottom: 0.30, // 12 inches = 0.30 meters
  },

  // Net dimensions
  net: {
    length: 0.46, // 18 inches = 0.46 meters
    segments: 12, // Number of vertical segments (reduced from 16)
    rings: 8, // Number of horizontal rings
  },

  // Hoop support structure
  hoopSupport: {
    mainPostWidth: 0.2, // Width of main support post
    mainPostDepth: 0.2, // Depth of main support post
    distanceFromBaseline: 1.2192, // 4 feet = 1.2192 meters
    armThickness: 0.05, // Thickness of support arms
  },

  // Three-point line dimensions
  threePointLine: {
    arcRadius: 7.24, // 23'9" = 7.24 meters from center of hoop
    straightLineLength: 4.27, // 14' from baseline = 4.27 meters
    distanceFromSideline: 0.91, // 3' from sideline = 0.91 meters
  },

  // Free throw line dimensions
  freeThrow: {
    distanceFromBaseline: 5.79, // 19 feet = 5.79 meters (length of the lane)
    circleRadius: 1.83, // 6 feet = 1.83 meters
  },

  // Lane dimensions
  lane: {
    width: 4.88, // 16 feet = 4.88 meters
    length: 5.79, // 19 feet = 5.79 meters
  },

  // Restricted area dimensions
  restrictedArea: {
    radius: 1.22, // 4 feet = 1.22 meters
  },

  // Physics properties for collision
  physics: {
    gravity: 9.81, // m/s²
    maxVelocity: 15, // Maximum velocity in any direction
    drag: 0.01, // Air resistance factor
  },

  scale: {
    x: 2,
    y: 2,
    z: 2
  },


  // Debug visualization settings
  debug: {
    showAxes: true, // Show coordinate system axes 
    axesSize: 5.0, // Size of the coordinate axes (length of each axis)
    axesColors: {
      x: 0xff0000, // Red for X-axis
      y: 0x00ff00, // Green for Y-axis
      z: 0x0000ff  // Blue for Z-axis
    }
  }
}; 